import React, { FC, useState } from 'react';
import { LoginModal } from '../login/LoginModal';
import { ModalWindow } from '../modal/ModalWindow';
import * as auth from '../../redux/AuthRedux';
import { fetchApiClientKeysDetail, useApiClientContext } from '../../store/api-client-context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { CodeModalProps } from '../../views/login/Login';
import { IAuthState } from '../../redux/AuthRedux';
import { RootState } from '../../../setup';

interface Props {
  isLoginVisible: boolean;
  closeModal: () => void;
  formik: any;
}
export const CustomKeyDetailsLoginForm: FC<Props> = (props) => {
  const { isLoginVisible, closeModal, formik } = props;

  const { clientId } = useParams();
  const dispatchAuth = useDispatch();
  const navigate = useNavigate();
  const authUser: IAuthState = useSelector<RootState>(({ auth }) => auth, shallowEqual);
  const userData = authUser.userData;

  const { dispatch } = useApiClientContext();
  const [codeModalState, setCodeModalState] = useState<CodeModalProps>({
    isOpen: false,
    session: '',
    email: ''
  });
  const handleLogOut = (): void => {
    closeModal();
    console.log('logout---006');
    dispatchAuth(auth.actions.logout());
    navigate('/');
  };

  const handleSuccessLogin = (user): void => {
    const loginData = {
      accessToken: user.data?.accessToken,
      idToken: user.data.id,
      userData: {
        ...userData,
        loginDate: new Date(),
      },
    };
    dispatchAuth(auth.actions.login(loginData));

    closeModal();
    void fetchApiClientKeysDetail(dispatch, clientId, formik);
  };

  return (
    <ModalWindow
      isOpen={isLoginVisible}
      modalTitle='Confirm password'
      onClose={handleLogOut}
      contentClassName="d-block"
      minHeight={50}
      backdrop="static"
      content={
        <LoginModal
          closeModal={closeModal}
          logOut={handleLogOut}
          setCodeModalState={setCodeModalState}
          handleSuccessLogin={handleSuccessLogin}
        />
      }
    />
  );
};
